"use strict";

exports.__esModule = true;
exports.TooltipWrapper = exports.TooltipLabel = exports.TooltipInner = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TooltipWrapper = _styledComponents.default.span`
    display: inline-block;
    margin-left: 5px;
`;
exports.TooltipWrapper = TooltipWrapper;
const TooltipInner = _styledComponents.default.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: 2px solid ${props => props.theme.colors.tooltipToggle.border};
    background-color: ${props => props.theme.colors.tooltipToggle.background};
    border-radius: 50%;
    cursor: help;
`;
exports.TooltipInner = TooltipInner;
const TooltipLabel = _styledComponents.default.span`
    display: block;
    font-size: ${props => props.theme.fontSizes[3]};
    font-weight: ${props => props.theme.fontWeights.medium};
    color: ${props => props.theme.colors.tooltipToggle.text};
    line-height: 100%;
`;
exports.TooltipLabel = TooltipLabel;